<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0002 23.0002L9.0002 20.0002H5.0002C4.46976 20.0002 3.96106 19.7895 3.58598 19.4144C3.21091 19.0393 3.0002 18.5306 3.0002 18.0002V4.0002C2.99643 3.73708 3.04657 3.47598 3.14753 3.23297C3.24848 2.98997 3.39811 2.7702 3.5872 2.5872C3.7702 2.39811 3.98997 2.24848 4.23297 2.14753C4.47598 2.04657 4.73708 1.99643 5.0002 2.0002H19.0002C19.2633 1.99643 19.5244 2.04657 19.7674 2.14753C20.0104 2.24848 20.2302 2.39811 20.4132 2.5872C20.6023 2.7702 20.7519 2.98997 20.8529 3.23297C20.9538 3.47598 21.004 3.73708 21.0002 4.0002V18.0002C21.0002 18.5306 20.7895 19.0393 20.4144 19.4144C20.0393 19.7895 19.5306 20.0002 19.0002 20.0002H15.0002L12.0002 23.0002Z"
      fill="#3CB149"
    />
    <path
      d="M12.0008 15.8258L13.5088 12.5088L16.8258 11.0008L13.5088 9.49278L12.0008 6.17578L10.4928 9.49278L7.17578 11.0008L10.4928 12.5088L12.0008 15.8258Z"
      fill="#FFC304"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
